import type {
  AdminGetAccountByEmailParams,
  AdminGetAccountByPhoneParams,
  AdminGetAccountParams,
  AdminGetMissionsParams,
  AdminGetUserByEmailParams,
  AdminGetUserByPhoneParams,
  AdminGetUserOtcHistoryParams,
  AdminGetUserParams,
  AdminGetUserPortfolioParams,
  AdminListAccountsParams,
  AdminListUserBankAccountsParams,
  AdminCreateAccountInput,
  AdminToggleAccountActiveInput,
} from '../api'
import adminAccountService from './admin-account.service'
import { EAdminAccountQueryKey } from './admin-account.types'

export const adminGetAccountOptions = (params: AdminGetAccountParams) => {
  return {
    queryKey: [EAdminAccountQueryKey.ADMIN_ACCOUNT, params],
    queryFn: () => adminAccountService.adminGetAccount(params),
  }
}

export const adminListAccountsOptions = (params: AdminListAccountsParams) => {
  return {
    queryKey: [EAdminAccountQueryKey.ADMIN_ACCOUNTS, params],
    queryFn: () => adminAccountService.adminListAccounts(params),
  }
}

export const adminGetAccountByEmailOptions = (
  params: AdminGetAccountByEmailParams,
) => {
  return {
    queryKey: [EAdminAccountQueryKey.ADMIN_ACCOUNT_BY_EMAIL, params],
    queryFn: () => adminAccountService.adminGetAccountByEmail(params),
  }
}

export const adminGetAccountByPhoneOptions = (
  params: AdminGetAccountByPhoneParams,
) => {
  return {
    queryKey: [EAdminAccountQueryKey.ADMIN_ACCOUNT_BY_PHONE, params],
    queryFn: () => adminAccountService.adminGetAccountByPhone(params),
  }
}

export const adminGetUserOptions = (params: AdminGetUserParams) => {
  return {
    queryKey: [EAdminAccountQueryKey.ADMIN_USER, params],
    queryFn: () => adminAccountService.adminGetUser(params),
  }
}

export const adminCreateAccountOptions = (params: AdminCreateAccountInput) => {
  return {
    mutationKey: [EAdminAccountQueryKey.ADMIN_ACCOUNTS, params],
    mutationFn: (data: AdminCreateAccountInput) =>
      adminAccountService.adminCreateAccount(data),
  }
}

export const adminToggleAccountActiveOptions = (
  params: AdminToggleAccountActiveInput,
) => {
  return {
    mutationKey: [EAdminAccountQueryKey.ADMIN_ACCOUNT, params],
    mutationFn: (data: AdminToggleAccountActiveInput) =>
      adminAccountService.adminToggleAccountActive(data),
  }
}

export const adminGetUserByEmailOptions = (
  params: AdminGetUserByEmailParams,
) => {
  return {
    queryKey: [EAdminAccountQueryKey.ADMIN_USER_BY_EMAIL, params],
    queryFn: () => adminAccountService.adminGetUserByEmail(params),
  }
}

export const adminGetUserByPhoneOptions = (
  params: AdminGetUserByPhoneParams,
) => {
  return {
    queryKey: [EAdminAccountQueryKey.ADMIN_USER_BY_PHONE, params],
    queryFn: () => adminAccountService.adminGetUserByPhone(params),
  }
}

export const adminGetUserByIdOptions = (params: AdminGetUserParams) => {
  return {
    queryKey: [EAdminAccountQueryKey.ADMIN_USER_BY_ID, params],
    queryFn: () => adminAccountService.adminGetUserById(params),
  }
}

export const adminGetMissionsOptions = (params: AdminGetMissionsParams) => {
  return {
    queryKey: [EAdminAccountQueryKey.ADMIN_MISSIONS, params],
    queryFn: () => adminAccountService.adminGetMissions(params),
  }
}

export const adminGetUserPortfolioOptions = (
  params: AdminGetUserPortfolioParams,
) => {
  return {
    queryKey: [EAdminAccountQueryKey.ADMIN_USER_PORTFOLIO, params],
    queryFn: () => adminAccountService.adminGetUserPortfolio(params),
  }
}

export const adminGetUserOtcHistoryOptions = (
  params: AdminGetUserOtcHistoryParams,
) => {
  return {
    queryKey: [EAdminAccountQueryKey.ADMIN_USER_OTC_HISTORY, params],
    queryFn: () => adminAccountService.adminGetUserOtcHistory(params),
  }
}

export const adminListUserBankAccountsOptions = (
  params: AdminListUserBankAccountsParams,
) => {
  return {
    queryKey: [EAdminAccountQueryKey.ADMIN_USER_BANK_ACCOUNTS, params],
    queryFn: () => adminAccountService.adminListUserBankAccounts(params),
  }
}
